import React from "react";
import TextField from "@material-ui/core/TextField";
import style from './style.css';

const InputField = ({ label, value, onChange, style, inputStyles, ...props }) => {
  return (
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      style={style}
      // fullWidth
      {...props}
      InputProps={{
        style:{
          backgroundColor:"white",
          ...inputStyles,
        }
      }}
    />
  );
};

export default InputField;
